import { getAPIendpointPrefix } from '../../client/actions/apiHelper'
import fetch from 'isomorphic-fetch'

function isSet (obj, prop, defaultVal) {
  if (obj[prop] !== undefined && obj[prop] !== null) {
    return obj[prop]
  }
  return defaultVal
}

export default function getConsulValues () {
  return fetch(getAPIendpointPrefix() + 'api/v1/lcconfig.php?GETCONFIG=true')
    .then(response => response.json())
    .then(json => {
      const environment = isSet(json, 'ENVIRONMENT', 'REPLACEME_ENVIRONMENT')
      const isLocalMachineEnvironment = (environment !== 'production' && environment !== 'staging' &&
        environment !== 'development' && environment !== 'dev' && environment !== 'int')

      if (isLocalMachineEnvironment) {
        return {
          NODE_ENV: process.env.NODE_ENV,
          HOSTNAME: process.env.HOSTNAME,
          ACTIVITY_HOSTNAME: process.env.ACTIVITY_HOSTNAME,
          ACTIVITY_BASE_PATH: process.env.ACTIVITY_BASE_PATH,
          DEFAULT_ACTIVITY_FILE: process.env.DEFAULT_ACTIVITY_FILE,
          IRT_STRATEGY: process.env.IRT_STRATEGY,
          ENVIRONMENT: process.env.ENVIRONMENT,
          INSTANA_KEY: process.env.INSTANA_KEY,
          PENDO_APP_ID: process.env.PENDO_APP_ID,
          FF_PENDO_ENABLED: process.env.FF_PENDO_ENABLED,
          FF_SECRET_KEY_ROTATION: process.env.FF_SECRET_KEY_ROTATION,
          ARROYO_URL: process.env.ARROYO_URL,
          FF_ARROYO_ENABLED: process.env.FF_ARROYO_ENABLED,
          FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED: process.env.FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED,
          FF_USE_LC_GRADE_SERVICE: process.env.FF_USE_LC_GRADE_SERVICE,
          LC_GRADE_SERVICE_URL: process.env.LC_GRADE_SERVICE_URL,
        }
      }

      const obj = {
        NODE_ENV: isSet(json, 'NODE_ENV', 'REPLACEME_NODE_ENVIRONMENT'),
        HOSTNAME: isSet(json, 'HOSTNAME', 'localhost'),
        ACTIVITY_HOSTNAME: isSet(json, 'ACTIVITY_HOSTNAME', 'REPLACEME_ACTIVITY_HOSTNAME'),
        ACTIVITY_BASE_PATH: isSet(json, 'ACTIVITY_BASE_PATH', 'REPLACEME_ACTIVITY_BASE_PATH'),
        DEFAULT_ACTIVITY_FILE: isSet(json, 'DEFAULT_ACTIVITY_FILE', 'REPLACEME_DEFAULT_ACTIVITY_FILE'),
        IRT_STRATEGY: isSet(json, 'IRT_STRATEGY', 'REPLACEME_IRT_STRATEGY'),
        ENVIRONMENT: isSet(json, 'ENVIRONMENT', ''),
        INSTANA_KEY: isSet(json, 'INSTANA_KEY', 'REPLACEME_INSTANA_KEY'),
        PENDO_APP_ID: isSet(json, 'PENDO_APP_ID', 'REPLACEME_PENDO_APP_ID'),
        FF_PENDO_ENABLED: isSet(json, 'FF_PENDO_ENABLED', 'REPLACEME_FF_PENDO_ENABLED'),
        ARROYO_URL: isSet(json, 'ARROYO_URL', 'REPLACEME_ARROYO_URL'),
        FF_ARROYO_ENABLED: isSet(json, 'FF_ARROYO_ENABLED', 'REPLACEME_FF_ARROYO_ENABLED'),
        FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED: isSet(json, 'FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED', 'REPLACEME_FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED'),
        FF_USE_LC_GRADE_SERVICE: isSet(json, 'FF_USE_LC_GRADE_SERVICE', 'false'),
        FF_SECRET_KEY_ROTATION: isSet(json, 'FF_SECRET_KEY_ROTATION', 'false'),
        LC_GRADE_SERVICE_URL: isSet(json, 'LC_GRADE_SERVICE_URL', 'http://localhost:8500'),
      }
      return obj
    })
    .catch((error) => {
      if (error) {
        console.log('Error fetching consul values', error)
      }
      return {
        NODE_ENV: process.env.NODE_ENV || 'REPLACEME_NODE_ENVIRONMENT',
        HOSTNAME: process.env.HOSTNAME || 'localhost',
        ACTIVITY_HOSTNAME: process.env.ACTIVITY_HOSTNAME || 'REPLACEME_ACTIVITY_HOSTNAME',
        ACTIVITY_BASE_PATH: process.env.ACTIVITY_BASE_PATH || 'REPLACEME_ACTIVITY_BASE_PATH',
        DEFAULT_ACTIVITY_FILE: process.env.DEFAULT_ACTIVITY_FILE || 'REPLACEME_DEFAULT_ACTIVITY_FILE',
        IRT_STRATEGY: process.env.IRT_STRATEGY || 'REPLACEME_IRT_STRATEGY',
        ENVIRONMENT: process.env.ENVIRONMENT || 'REPLACEME_ENVIRONMENT',
        INSTANA_KEY: process.env.INSTANA_KEY || 'REPLACEME_INSTANA_KEY',
        PENDO_APP_ID: process.env.PENDO_APP_ID || 'REPLACEME_PENDO_APP_ID',
        FF_PENDO_ENABLED: process.env.FF_PENDO_ENABLED || 'REPLACEME_FF_PENDO_ENABLED',
        ARROYO_URL: process.env.ARROYO_URL || 'REPLACEME_ARROYO_URL',
        FF_ARROYO_ENABLED: process.env.FF_ARROYO_ENABLED || 'REPLACEME_FF_ARROYO_ENABLED',
        FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED: process.env.FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED || 'REPLACEME_FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED',
        FF_SECRET_KEY_ROTATION: process.env.FF_SECRET_KEY_ROTATION || 'false',
        FF_USE_LC_GRADE_SERVICE: process.env.FF_USE_LC_GRADE_SERVICE || 'false',
        LC_GRADE_SERVICE_URL: process.env.LC_GRADE_SERVICE_URL || 'http://localhost:8500',
      }
    })
}

export function insertInstanaScript (key) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.text = `(function(i,s,o,g,r,a,m){i['InstanaEumObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//eum.instana.io/eum.min.js','ineum');
  ineum('reportingUrl', 'https://eum-us-west-2.instana.io');
  ineum('key', '${key}');`

  document.head.appendChild(s)
}

export function insertPendoScript (key) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.text = `(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
  v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
  y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
  })('${key}');`

  document.head.appendChild(s)
}

export function initPendo(userId, lc_origin) {
  try {
    const pendo = window.pendo || {};
    const pendoVisitorId = pendo.visitorId;
    if (!pendoVisitorId) {
      pendo.initialize({ visitor: { id: userId, lc_origin: lc_origin } });
    }
  } catch (e) {
    console.error('Error while initializing Pendo', e.message);
  }
}

export function insertArroyoScript (arroyoUrl) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.text = `(()=>{var e,_,o,n,r,t,A,E,O;e=window,_=document,o="script",n="${arroyoUrl}",r="_arroyo",t="LearningCurve",
  A=console.log,e.AYO_BASE_URL=e.AYO_BASE_URL||n,n=new URL("/arroyo.js",e.AYO_BASE_URL).toString(),e.AYO_FUNC_NAME=r,e.AYO_SUBSYSTEM=t,
  e.AYO_LOG_FUNC=A,e[r]=e[r]||function(){(e[r].queue=e[r].queue||[]).push(arguments[0])},(E=_.createElement(o)).async=1,
  E.src=n,[O]=_.getElementsByTagName(o),O.parentNode.insertBefore(E,O)})();`

  document.head.appendChild(s)
}
